<template>
  <ScaleBox v-if="isMobile">
    <router-view></router-view>
  </ScaleBox>
  <router-view v-else></router-view>
</template>

<script>
import ScaleBox from "./components/ScaleBox.vue"
export default {
  name: "App",
  components: {
    ScaleBox
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      debounceTimeout: null
    }
  },
  computed: {
    isMobile() {
      console.log(this.windowWidth, '宽度')
      return this.windowWidth < 768;
    }
  },
  methods: {
    debounceResize() {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.calculateHeight();
      }, 200);
    },
    calculateHeight() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener('resize', this.debounceResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debounceResize);
  }
};
</script>

<style>
body,html{
  width: 100%;
  height: 100%;
}
body{
  margin: 0;
  padding: 0;
  background: #F2F5FA;
  font-family: "PingFangSC-Light", "Microsoft YaHei", Roboto,Helvetica Neue Light, Tahoma, "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif !important;
}
button,input{
  font-family: "PingFangSC-Light", "Microsoft YaHei", Roboto,Helvetica Neue Light, Tahoma, "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif !important;
}
#app {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/App.vue